<div>
  <h3>Year-to-date</h3>
    <div *ngIf="chartInfo">
      <canvas #canvasEl id="chart"></canvas>
    </div>
</div>